import React from 'react';
import { Link, browserHistory } from 'react-router';
import { routes, accountConstants, fetchTypes, requestStatus } from '../constants';
import { connect } from 'react-redux';
import { RouteActions, ResourceActions } from '../actions';
import { AuthComponent, Card, CompletedReportGrid, DataGridPager, Menu, MenuItem, PendingSampleGrid, ReportAccessGrid, SearchControls, Tab, TabSet } from '../components';
import { AuthDelegate } from '../utils';

const { statuses, roles } = accountConstants;

const tabs = {
    COMPLETED_REPORTS: 'COMPLETED_REPORTS',
    PENDING_SAMPLES: 'PENDING_SAMPLES',
    REPORT_ACCESS: 'REPORT_ACCESS'
}

const anySearchableFields = [
    {
        key: 'serialNumber',
        name: 'Serial Number'
    }, {
        key: 'sampleNumber',
        name: 'Sample Number'
    }, {
        key: 'fluidType',
        name: 'Fluid Type'
    }
]

const oemSearchableFields = [
    ...anySearchableFields,
    {
        key: 'distributorName',
        name: 'Distributor Name'
    }, {
        key: 'customerName',
        name: 'Customer Name'
    }
]

const distributorSearchableFields = [
    ...anySearchableFields,
    {
        key: 'oemName',
        name: 'OEM Name'
    }, {
        key: 'customerName',
        name: 'Customer Name'
    }
]

const customerSearchableFields = [
    ...anySearchableFields,
    {
        key: 'distributorName',
        name: 'Distributor Name'
    }, {
        key: 'oemName',
        name: 'OEM Name'
    }
]

const adminSearchableFields = [
    ...anySearchableFields,
    {
        key: 'customerName',
        name: 'Customer Name'
    }, {
        key: 'distributorName',
        name: 'Distributor Name'
    }, {
        key: 'oemName',
        name: 'OEM Name'
    }
]

class HomePage extends AuthComponent {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: tabs.COMPLETED_REPORTS,
            lastCompletedSearch: {},
            lastPendingSearch: {},
            lastReportAccessSearch: {}
        }
    }

    userDidAuthorize() {
        this.queryCompleted();
        this.queryPending();
        if (AuthDelegate.userHasRole(roles.ADMIN))
        {
            this.queryHistory();
        }
    }

    userIsAuthorized(user) {
        return AuthDelegate.userHasApprovalState(statuses.APPROVED)(user);
    }

    componentWillRejectUser() {
        browserHistory.push(routes.LOGIN);
    }

    componentDidMount() {
        this.props.dispatch(RouteActions.setAppState(routes.HOME));
    }

    queryCompleted(params = {}) {
        params = Object.assign({}, {
            isComplete: true,
            sortOrder: 'DESC' //hardcode sort order to have most recent at the top
        }, params);
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.REPORT_SEARCH, params));
        this.setState({
            lastCompletedSearch: params
        });
    }

    exportCompleted(params) {
        params = Object.assign({}, {
            isComplete: true
        }, params);
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.COMPLETED_REPORT_SEARCH_EXPORT, params));
    }

    queryPending(params = {}, reset) {
        params = Object.assign({}, {
            isComplete: false,
            sortOrder: 'DESC' //hardcode sort order to have most recent at the top
        }, reset ? {} : this.props.pendingSamples.searchparams, params);
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.PENDING_REPORT_SEARCH, params));
        this.setState({
            lastPendingSearch: params
        });
    }

    queryHistory(params = {}, reset) {
        params = Object.assign({}, {
        }, reset ? {} : this.props.reportAccess.searchparams, params);
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.REPORT_ACCESS, params));
        this.setState({
            lastReportAccessSearch: params
        });
    }

    exportPending(params) {
        params = Object.assign({}, {
            isComplete: false
        }, params);
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.PENDING_REPORT_SEARCH_EXPORT, params));
    }

    menuDidUpdate(id) {
        this.setState({
            activeTab: id
        });

        switch (id) {
            case tabs.COMPLETED_REPORTS:

                break;
            default:

        }
    }

    emptyCompletedGrid() {
        return (
            <div className="center row">
                <div className="col-sm-5 center">
                    <h3>No Completed Reports</h3>
                </div>
            </div>
        )
    }

    emptyPendingGrid() {
        return (
            <div className="center row">
                <div className="col-sm-5 center">
                    <h3>No Pending Samples</h3>
                    <p>
                        <Link to="/">Download the iPhone app</Link> from the app store to submit samples. The new iPhone app features a barcode scanner.
                    </p>
                </div>
            </div>
        )
    }

    emptyHistoryGrid() {
        return (
            <div className="center row">
                <div className="col-sm-5 center">
                    <h3>No Access History</h3>
                    <p>
                        <Link to="/">Download the iPhone app</Link> from the app store to submit samples. The new iPhone app features a barcode scanner.
                    </p>
                </div>
            </div>
        )
    }

    get completedPagerConfig() {
        let {pageSize, currentPageNumber, totalItemCount, totalPageCount} = this.props.completedReports;
        return {
            pageSize,
            currentPageNumber,
            totalItemCount,
            totalPageCount,
            onPageChange: (newPage) => {
                this.queryCompleted(Object.assign(this.state.lastCompletedSearch || {}, {
                    pageNumber: newPage
                }));
            }
        }
    }

    get pendingPagerConfig() {
        let {pageSize, currentPageNumber, totalItemCount, totalPageCount} = this.props.pendingSamples;
        return {
            pageSize,
            currentPageNumber,
            totalItemCount,
            totalPageCount,
            onPageChange: (newPage) => {
                this.queryPending(Object.assign(this.state.lastPendingSearch || {}, {
                    pageNumber: newPage
                }));
            }
        }
    }

    get reportAccessPagerConfig() {
        let {pageSize, currentPageNumber, totalItemCount, totalPageCount} = this.props.reportAccess;
        return {
            pageSize,
            currentPageNumber,
            totalItemCount,
            totalPageCount,
            onPageChange: (newPage) => {
                this.queryHistory(Object.assign(this.state.lastReportAccessSearch || {}, {
                    pageNumber: newPage
                }));
            }
        }
    }

    authRender() {

        let searchableFields =
            AuthDelegate.userHasRole(roles.ADMIN)(this.props.user) ? adminSearchableFields :
            AuthDelegate.userHasRole(roles.SALESPERSON)(this.props.user) ? adminSearchableFields :
            AuthDelegate.userHasRole(roles.CUSTOMER)(this.props.user) ? customerSearchableFields :
            AuthDelegate.userHasRole(roles.DISTRIBUTOR)(this.props.user) ? distributorSearchableFields :
            AuthDelegate.userHasRole('Oem')(this.props.user) ? oemSearchableFields :
            [];

        if (this.state.activeTab == tabs.REPORT_ACCESS){
            searchableFields = [
                {
                    key: 'serialNumber',
                    name: 'Serial Number'
                }, {
                    key: 'sampleNumber',
                    name: 'Sample Number'
                }                , {
                    key: 'customerName',
                    name: 'Customer'
                }
            ];
        }

        return (
            <div className="container" id="container-home">
                <div className="row">
                    <div className="col-sm-12">
                        <Card>
                            <div className="card-title-area">
                                <Menu className="no-collapsesample-view-menu" defaultItem={ tabs.COMPLETED_REPORTS } onChange={ key => this.menuDidUpdate(key) }>
                                    <MenuItem itemId={ tabs.COMPLETED_REPORTS }>Completed</MenuItem>
                                    <MenuItem itemId={ tabs.PENDING_SAMPLES }>Incoming</MenuItem>
                                    {AuthDelegate.userHasRole(roles.ADMIN) ? <MenuItem itemId={ tabs.REPORT_ACCESS }>Access History</MenuItem> : null}
                                </Menu>
                            </div>

                            <div className="card-body row">
                                <TabSet className="desktop-padding" switch={this.state.activeTab}>
                                    <Tab value={tabs.COMPLETED_REPORTS}>
                                        <SearchControls
                                            className="col-sm-12"
                                            searchableFields={searchableFields}
                                            onSearch={params => this.queryCompleted(params)}
                                            onExport={params => this.exportCompleted(params)}
                                            exportBusy={this.props.completedExport.isLoading} />
                                        <CompletedReportGrid
                                            className="col-sm-12"
                                            data={this.props.completedReports.results}
                                            emptyPlaceholder={this.emptyCompletedGrid()}
                                            isLoading={this.props.completedReports.progress === requestStatus.BUSY} />
                                        <DataGridPager className="col-sm-12" config={this.completedPagerConfig} />
                                    </Tab>
                                    <Tab value={tabs.PENDING_SAMPLES}>
                                        <SearchControls
                                            className="col-sm-12"
                                            searchableFields={searchableFields}
                                            onSearch={params => this.queryPending(params)} />
                                        <PendingSampleGrid
                                            className="col-sm-12"
                                            data={this.props.pendingSamples.results}
                                            emptyPlaceholder={this.emptyPendingGrid()}
                                            isLoading={this.props.pendingSamples.progress === requestStatus.BUSY} />
                                        <DataGridPager config={this.pendingPagerConfig} />
                                    </Tab>
                                    <Tab value={tabs.REPORT_ACCESS}>
                                        <SearchControls
                                            className="col-sm-12"
                                            searchableFields={searchableFields}
                                            onSearch={params => this.queryHistory(params)} />
                                        <ReportAccessGrid
                                            className="col-sm-12"
                                            data={this.props.reportAccess.results}
                                            emptyPlaceholder={this.emptyHistoryGrid()}
                                            isLoading={this.props.reportAccess.progress === requestStatus.BUSY} />
                                        <DataGridPager config={this.reportAccessPagerConfig} />
                                    </Tab>
                                </TabSet>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

function select(state) {

    return {
        appState: state.appState.currentRoute,
        user: state.activeUser,
        completedReports: state.completedReports,
        completedSearchParams: state.completedReports.searchParams,
        completedExport: state.completedReportSearchExport,
        pendingSamples: state.pendingSamples,
        pendingSearchParams: state.pendingSamples.searchParams,
        pendingExport: state.pendingReportSearchExport,
        reportAccess: state.reportAccess,
        reportAccessSearchParams: state.reportAccess.searchParams
    }
}

export default connect(select)(HomePage);



// WEBPACK FOOTER //
// ./web-app/containers/home.jsx